<template>
  <DashboardContainer>
    <div style="display: flex; justify-content: center">
      <BuyPlan
        title="Starter"
        price="$9.99 / month"
        :active="user.plan == 'STARTER'"
      >
        <template #features>
          <div>1 Websites</div>
          <div>1 Team member</div>
          <div>Blog CMS</div>
          <div>Custom domain usage</div>
          <div>E-mail Support</div>
        </template>
        <template #cta>
          <stripe-checkout
            ref="checkoutRefStarter"
            :pk="publishableKey"
            :items="starterItems"
            :successUrl="successUrl"
            :cancelUrl="cancelUrl"
            :customerEmail="email"
          >
            <template slot="checkout-button">
              <v-btn
                color="primary"
                rounded
                width="100%"
                @click="$refs.checkoutRefStarter.redirectToCheckout()"
                elevation="0"
              >
                Buy
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </stripe-checkout>
        </template>
      </BuyPlan>
      <BuyPlan
        title="Lite"
        price="$14.99 / month"
        style="margin-left: 10px"
        :active="user.plan == 'LITE'"
      >
        <template #features>
          <div>3 Websites</div>
          <div>10 Team members</div>
          <div>Blog CMS</div>
          <div>Custom domain usage</div>
          <div>Universal Blocks</div>
          <div>E-mail Support</div>
        </template>
        <template #cta>
          <stripe-checkout
            ref="checkoutRefLite"
            :pk="publishableKey"
            :items="liteItems"
            :successUrl="successUrl"
            :cancelUrl="cancelUrl"
            :customerEmail="email"
          >
            <template slot="checkout-button">
              <v-btn
                color="primary"
                rounded
                width="100%"
                @click="$refs.checkoutRefLite.redirectToCheckout()"
                elevation="0"
              >
                Buy
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </stripe-checkout>
        </template>
      </BuyPlan>
      <BuyPlan
        title="Premium"
        price="$39.99 / month"
        style="margin-left: 10px"
        :active="user.plan == 'PREMIUM'"
      >
        <template #features>
          <div>30 Websites</div>
          <div>>10 Team members</div>
          <div>Blog CMS</div>
          <div>Custom domain usage</div>
          <div>Universal Blocks</div>
          <div>E-mail, Live Support</div>
        </template>
        <template #cta>
          <stripe-checkout
            ref="checkoutRefPremium"
            :pk="publishableKey"
            :items="premiumItems"
            :successUrl="successUrl"
            :cancelUrl="cancelUrl"
            :customerEmail="email"
          >
            <template slot="checkout-button">
              <v-btn
                color="primary"
                rounded
                width="100%"
                @click="$refs.checkoutRefPremium.redirectToCheckout()"
              >
                Buy
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </stripe-checkout>
        </template>
      </BuyPlan>
    </div>
  </DashboardContainer>
</template>

<script>
import { mapState } from "vuex";
import DashboardContainer from "../components/DashboardContainer";
import BuyPlan from "../components/BuyPlan";
import { StripeCheckout } from "vue-stripe-checkout";

export default {
  components: {
    DashboardContainer,
    BuyPlan,
    StripeCheckout,
  },
  computed: {
    ...mapState(["user"]),
    email() {
      return this.user ? this.user.email : "";
    },
  },
  data() {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      starterItems: [
        {
          plan: "plan_HJYrDyIlLHkpsp",
          quantity: 1,
        },
      ],
      liteItems: [
        {
          plan: "plan_HJYtdEICBpnBqO",
          quantity: 1,
        },
      ],
      premiumItems: [
        {
          plan: "plan_HJYu5uuKwamf9Z",
          quantity: 1,
        },
      ],
      successUrl:
        document.location.origin +
        "/#/buy/success?session_id={CHECKOUT_SESSION_ID}",
      cancelUrl: document.location.origin + "/#/buy/",
    };
  },
  created() {
    document.title = "Buy - Landly Console";
    const testPlanIdFromRoute = this.$route.query.id;
    if (testPlanIdFromRoute) {
      this.starterItems[0].plan = testPlanIdFromRoute;
      this.liteItems[0].plan = testPlanIdFromRoute;
      this.premiumItems[0].plan = testPlanIdFromRoute;
    }
  },
};
</script>